import "./Batch.scss";
import _ from "lodash";
import Button from "../../Button";
import BatchForm from "./BatchForm";
import BatchListView from "./ListView";
import Card from "react-bootstrap/Card";
import constants from "../../../constants";
import { getDataFromStorage } from "../../../util";
import "react-datepicker/dist/react-datepicker.css";
import AlertContext from "../../../context/AlertContext";
import useAxiosPrivate from "../../../Hooks/useAxiosPrivate";
import ToggleButton from "../../CommonComponents/ToggleButton";
import Loading from "../../Notification-Loading/Loading/Loading";
import React, { useEffect, useContext, useState, useMemo } from "react";
import Tooltip from "../../CommonComponents/Tooltip";
import IconButton from "../../CommonComponents/IconButton";
import Tabs from "../../CommonComponents/Tabs";
import RequestTypeToggle from "../../CommonComponents/RequestTypeToggle";
import Search from "../../CommonComponents/Search";

export default function Batches() {
  const [typeFilter, setTypeFilter] = useState("All");
  const {
    navigate,
    isLoaded,
    setIsLoaded,
    setShowNotify,
    batchGridView,
    setBatchNames,
    isBatchDetails,
    setBatchGridView,
  } = useContext(AlertContext);

  const axios = useAxiosPrivate();

  let role = useMemo(() => getDataFromStorage("role"), []);

  const [batches, setBatches] = useState([]);
  const [filterBatches, setFilterBatches] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [showPopUp, setShowPopUp] = useState(false);
  const [showArchived, setShowArchived] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [selected, setSelected] = useState(
    getDataFromStorage("role") !== constants.Roles.hr
      ? "Learning"
      : "Evaluation",
  );

  // const handleBatchDetails = (batchid, batchdate) => {
  //   navigate(`/batches/${batchid}/performance`);
  // };

  const handleBatchDetails = (batchid, batchdate,batchType) => {
    const accountType = Number(localStorage.getItem("university_type"));
    console.log("Accounts Dected !!!", accountType);
    if (accountType === constants.ACCOUNT_TYPE.CORPORATE) {
      console.log("Corporate account hitted !!!");
      console.log("Batch Type is : ", batchType);
      if (batchType === "Evaluation") {
        navigate(`/batches/${batchid}/dashboard?scope-ar=assignment-status`);
      } else {
        navigate(`/batches/${batchid}/dashboard?scope-ar=attendance`);
      }
    } else {
      navigate(`/batches/${batchid}/performance`);
    }
  }

  useEffect(() => {
    const fetchBatchList = async () => {
      try {
        setIsLoaded(true);

        const url = `node/admin/batch?archived=${showArchived}${[
            constants.Roles.trainer,
            constants.Roles.tutor,
            constants.Roles.hr,
            constants.Roles.evaluator,
          ].includes(role)
            ? `&role=${role}`
            : ""
          }`;

        {
          /* for batch grouping
            &type=${selected === "Learning" ? constants.BATCH_TYPE.LEARNING : selected === "Evaluation" ? constants.BATCH_TYPE.TESTING : constants.BATCH_TYPE.SELF} */
        }

        const response = await axios.get(url, {
          headers: {
            "Content-type": "application/json",
          },
        });

        if (response.data && response.data.length > 0) {
          setBatches(response.data);
          setFilterBatches(response.data);
          setBatchNames(_.map(response.data, (batch) => batch.name));
          setSearchValue("");
          if (role !== constants.Roles.super_admin) {
            const companyId = getDataFromStorage("companyId");
            const { data } = await axios.get(`node/admin/company/${companyId}`);
            let dataToStore = { ...data.data, premium_features: data.data.premium_data };
            const encodedData = btoa(JSON.stringify(dataToStore));
            localStorage.setItem("account_response", encodedData);
          }
        } else {
          setBatches([]);
          if (role === constants.Roles.evaluator) {
            setShowNotify({
              show: true,
              title: "Info",
              msg: "You are not part of any batch. You will be logged out for security reasons.",
              isUnAuth: true,
            });
          } else {
            setShowNotify({
              show: false,
              title: "Warning !",
              msg: "There is no batch",
            });
          }
        }
      } catch (error) {
        if (error.message.includes("403")) {
          setShowNotify({
            show: true,
            title: "Warning !",
            msg: "You have been logged-out due to inactivity. Login again.",
            isUnAuth: true,
          });
        } else {
          setShowNotify({
            show: true,
            title: "Error !",
            msg: "Something went wrong. Please try again later.",
          });
        }
      } finally {
        setIsLoaded(false);
      }
    };

    if (!showPopUp) {
      fetchBatchList();
    }
  }, [
    axios,
    isBatchDetails,
    showArchived,
    setShowNotify,
    setBatchNames,
    setIsLoaded,
    showPopUp,
    role,
    selected,
  ]);

  const handleSearchBatch = (event) => {
    event.preventDefault();
    let inputValue = event.target.value;
    setSearchValue(inputValue);
    let filtered = batches.filter((bat) =>
      bat.name?.toLowerCase().includes(inputValue?.toLowerCase()),
    );
    setFilterBatches(filtered);
  };

  return (
    <>
      <div className="adminBatchContainer">
        <div className="adminBatchInnerContainer">
          <div style={{ padding: "16px 20px" }}>
            <div className="addBatchBtn">
              <div className="batchTypeFilterContainer">
                {[
                  { label: "All", value: "All" },
                  { label: "Live Class", value: "Learning" },
                  { label: "Evaluation", value: "Evaluation" },
                  { label: "Self-Paced", value: "Self-Paced" },
                ].map((item) => (
                  <div
                    key={item.value}
                    onClick={() => setTypeFilter(item.value)}
                    className={
                      typeFilter === item.value
                        ? "batchTypeFilterItem batchTypeFilterItemActive"
                        : "batchTypeFilterItem"
                    }
                  >
                    {item.label}
                  </div>
                ))}
              </div>
              {getDataFromStorage("role") !== constants.Roles.hr &&
                getDataFromStorage("role") !== constants.Roles.tutor &&
                getDataFromStorage("role") !== constants.Roles.evaluator && (
                  <div className="allOptionsInBatch">
                    {/* <div className="viewOptions">
                    <div
                      className="listViewOfBatches"
                      onClick={() => {
                        setBatchGridView(false);
                      }}
                    >
                      <svg
                          className="batchesListView"
                          width="18"
                          height="14"
                          viewBox="0 0 18 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M16.5 7.00033L6.5 7.00033M16.5 2.00033L6.5 2.00033M16.5 12.0003L6.5 12.0003M3.16667 7.00033C3.16667 7.46056 2.79357 7.83366 2.33333 7.83366C1.8731 7.83366 1.5 7.46056 1.5 7.00033C1.5 6.54009 1.8731 6.16699 2.33333 6.16699C2.79357 6.16699 3.16667 6.54009 3.16667 7.00033ZM3.16667 2.00033C3.16667 2.46056 2.79357 2.83366 2.33333 2.83366C1.8731 2.83366 1.5 2.46056 1.5 2.00033C1.5 1.54009 1.8731 1.16699 2.33333 1.16699C2.79357 1.16699 3.16667 1.54009 3.16667 2.00033ZM3.16667 12.0003C3.16667 12.4606 2.79357 12.8337 2.33333 12.8337C1.8731 12.8337 1.5 12.4606 1.5 12.0003C1.5 11.5401 1.8731 11.167 2.33333 11.167C2.79357 11.167 3.16667 11.5401 3.16667 12.0003Z"
                            stroke="#101828"
                            strokeWidth="1.4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                    </div>
                    <div
                      className="gridViewOfBatches"
                      onClick={() => {
                        setBatchGridView(true);
                      }}
                    >
                      {batchGridView ? (
                        <svg
                          className="batchesGridView"
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.33333 1.5H1.5V7.33333H7.33333V1.5Z"
                            stroke="#101828"
                            strokeWidth="1.4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M16.5 1.5H10.6667V7.33333H16.5V1.5Z"
                            stroke="#101828"
                            strokeWidth="1.4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M16.5 10.6667H10.6667V16.5H16.5V10.6667Z"
                            stroke="#101828"
                            strokeWidth="1.4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M7.33333 10.6667H1.5V16.5H7.33333V10.6667Z"
                            stroke="#101828"
                            strokeWidth="1.4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      ) : (
                        <svg
                          className="disableBatchesGridView"
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.33333 1.5H1.5V7.33333H7.33333V1.5Z"
                            stroke="#667085"
                            strokeWidth="1.4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M16.5 1.5H10.6667V7.33333H16.5V1.5Z"
                            stroke="#667085"
                            strokeWidth="1.4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M16.5 10.6667H10.6667V16.5H16.5V10.6667Z"
                            stroke="#667085"
                            strokeWidth="1.4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M7.33333 10.6667H1.5V16.5H7.33333V10.6667Z"
                            stroke="#667085"
                            strokeWidth="1.4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      )}
                    </div>
                  
                  </div> */}

                    {/* <input
                    type="text"
                    name="search"
                    id="adminBatchSearchBox"
                    placeholder="Search"
                    onChange={handleSearchBatch}
                    value={searchValue}
                    className="adminBatchSearchBox"
                  /> */}

                    {/* <Tooltip title="Refresh" isIcon={true}>
                    <IconButton
                      hierarchy="tertiaryGrey"
                      onClick={() => setRefresh(true)}
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.6665 8.33333C1.6665 8.33333 3.33732 6.05685 4.6947 4.69854C6.05208 3.34022 7.92783 2.5 9.99984 2.5C14.142 2.5 17.4998 5.85786 17.4998 10C17.4998 14.1421 14.142 17.5 9.99984 17.5C6.58059 17.5 3.69576 15.2119 2.79298 12.0833M1.6665 8.33333V3.33333M1.6665 8.33333H6.6665"
                          stroke="#667085"
                          strokeWidth="1.66667"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </IconButton>
                  </Tooltip> */}
                    <Search
                      placeholder="Search Batch"
                      value={searchValue}
                      width={"200px"}
                      onChange={handleSearchBatch}
                      iconPosition="end"
                    />
                    <div className="archiveBatchSwitchDiv">
                      {/* <Tooltip title="View Archive" isIcon={true}> */}
                      <ToggleButton
                        size="sm"
                        text="View Archive"
                        supportingText=""
                        pressed={showArchived}
                        theme="Dark"
                        disabled={false}
                        onChange={(e) => setShowArchived(!showArchived)}
                      />
                      {/* </Tooltip> */}
                    </div>
                    <div id="addBatch">
                      <Button
                        size="sm"
                        hierarchy={{
                          type: "secondaryGrey",
                          buttonText: "New Batch",
                        }}
                        icon={{
                          type: "leading",
                          icon: (
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M10.0013 4.16699V15.8337M4.16797 10.0003H15.8346"
                                stroke="#344054"
                                strokeWidth="1.67"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          ),
                        }}
                        onClick={() => setShowPopUp(true)}
                      />
                    </div>
                  </div>
                )}
            </div>
            {showPopUp && (
              <BatchForm
                showPopUp={showPopUp}
                setShowPopUp={setShowPopUp}
                setRefresh={setRefresh}
              />
            )}
          </div>
          {/* <div className="batchTypeTabsContainer">
                <Tabs className="batchTypeTabs" tabItems={tabs} defaultTab={type}/>
        </div> */}
          {/* {batchGridView ? (
          <div className="adminBatchCardContainer">
            {_.map(filterBatches, (batch) => (
              <Card
                key={batch.id}
                id="adminBatchCard"
                onClick={() => handleBatchDetails(batch.id, batch.startdate)}
              >
                <Card.Img
                  variant="top"
                  id="adminBatchImg"
                  src={batch.thumbnail}
                />
                <Card.Body className="adminBatchCardBody">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div className="adminBatchName">{batch.name}</div>
                    <div className="adminBatchStartDate">
                      Start Date :{" "}
                      {(new Date(batch.startdate).getDate() > 9
                        ? new Date(batch.startdate).getDate()
                        : `0${new Date(batch.startdate).getDate()}`) +
                        "/" +
                        (new Date(batch.startdate).getMonth() + 1 > 9
                          ? new Date(batch.startdate).getMonth() + 1
                          : `0${new Date(batch.startdate).getMonth() + 1}`) +
                        "/" +
                        new Date(batch.startdate).getFullYear()}
                    </div>
                  </div>
                  <Card.Text id="adminBatchDes" title={batch.description}>
                    {batch.description
                      ? batch.description.length > 100
                        ? batch.description.substring(0, 100) + "..."
                        : batch.description.substring(0, 100)
                      : ""}
                  </Card.Text>
                </Card.Body>
              </Card>
            ))}
          </div>
        ) : (
          <div className="adminBatchTableContainer">
            <BatchListView
              data={filterBatches}
              showArchived={showArchived}
              handleBatchDetails={handleBatchDetails}
              from="batch"
            />
          </div>
        )} */}

          <div className="adminBatchTableContainer">
            <BatchListView
              data={filterBatches}
              showArchived={showArchived}
              handleBatchDetails={handleBatchDetails}
              from="batch"
              typeFilter={typeFilter}
            />
          </div>
          {isLoaded && <Loading overlay />}
          <div />
        </div>
      </div>

    </>
  );
}
